/**
 * Image With Text - Hotspot Interactive Drag Helper
 * Allows merchants to drag checkpoints directly on the image in Shopify Theme Customizer
 * to preview and view real-time X/Y coordinates for easy slider adjustments.
 */
(function () {
	'use strict';

	function initHotspotDrag() {
		// Only enable drag-to-inspect in Theme Editor (designMode)
		var isDesignMode = (window.Shopify && window.Shopify.designMode) || document.body.classList.contains('shopify-editor');
		if (!isDesignMode) return;

		var hotspots = document.querySelectorAll('.image-with-text .thb-hotspot');
		hotspots.forEach(function (hotspot) {
			if (hotspot.dataset.dragInitialized) return;
			hotspot.dataset.dragInitialized = 'true';

			var media = hotspot.closest('.image-with-text__image-media');
			if (!media) return;

			var badge = hotspot.querySelector('.thb-hotspot-coord-badge');
			if (!badge) {
				badge = document.createElement('div');
				badge.className = 'thb-hotspot-coord-badge';
				hotspot.appendChild(badge);
			}

			function updateBadge(x, y) {
				badge.textContent = 'X: ' + Math.round(x) + '% | Y: ' + Math.round(y) + '%';
			}

			var initialX = parseFloat(hotspot.style.getPropertyValue('--x-pos')) || 20;
			var initialY = parseFloat(hotspot.style.getPropertyValue('--y-pos')) || 20;
			updateBadge(initialX, initialY);

			var isDragging = false;

			hotspot.addEventListener('pointerdown', function (e) {
				if (e.button !== 0) return;
				isDragging = true;
				hotspot.classList.add('is-dragging');
				if (hotspot.setPointerCapture) {
					hotspot.setPointerCapture(e.pointerId);
				}
				e.stopPropagation();
				e.preventDefault();
			});

			hotspot.addEventListener('pointermove', function (e) {
				if (!isDragging) return;
				var rect = media.getBoundingClientRect();
				var x = ((e.clientX - rect.left) / rect.width) * 100;
				var y = ((e.clientY - rect.top) / rect.height) * 100;

				x = Math.max(0, Math.min(100, x));
				y = Math.max(0, Math.min(100, y));

				hotspot.style.setProperty('--x-pos', x.toFixed(1) + '%');
				hotspot.style.setProperty('--y-pos', y.toFixed(1) + '%');
				hotspot.style.left = x.toFixed(1) + '%';
				hotspot.style.top = y.toFixed(1) + '%';
				updateBadge(x, y);
			});

			function endDrag(e) {
				if (!isDragging) return;
				isDragging = false;
				hotspot.classList.remove('is-dragging');
				if (hotspot.releasePointerCapture) {
					try {
						hotspot.releasePointerCapture(e.pointerId);
					} catch (_) {}
				}
			}

			hotspot.addEventListener('pointerup', endDrag);
			hotspot.addEventListener('pointercancel', endDrag);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initHotspotDrag);
	} else {
		initHotspotDrag();
	}

	document.addEventListener('shopify:section:load', initHotspotDrag);
	document.addEventListener('shopify:block:select', initHotspotDrag);
})();
